import { responseService } from '@aceroll/platform-hacksaw';

// controllers
import { EvFeatureExit } from '../controllers/ev-feature-exit';
import { RoundCompleted } from '../controllers/round-completed';

export function evMaxWinDecision() {
    const event = responseService.getEvent();
    if (!event) {
        return RoundCompleted;
    }
    switch (event.type) {
        case 'feature_exit':
            return EvFeatureExit;
        default:
            throw new Error('Event is not provided');
    }

}